// extracted by css-extract-rspack-plugin
export default {"coinContainer":"coinContainer-2Cr3D","coin":"coin-3UHCd","overflow":"overflow-2reIW","overflowText":"overflowText-1kuHT"};